import Flex from 'UIKit/Box/Flex'
import { ResponsiveGameCollection } from 'config/types/game'
import styled from 'styled-components'
import { HunnyTheme } from 'theme/types'
import { buildResponsiveStyle } from 'utils/styled'

export const buildResponsiveContainerGap = (props: ResponsiveGameCollection & { theme: HunnyTheme }) => {
  const { gap, theme } = props
  const parsedGap = Array.isArray(gap) ? gap.map((item) => `calc(100% + ${item * 2}px)`) : `calc(100% + ${gap * 2}px)`
  return buildResponsiveStyle(theme, 'width', parsedGap)
}

export const buildResponsiveContainerMarginLeft = (props: ResponsiveGameCollection & { theme: HunnyTheme }) => {
  const { gap, theme } = props
  const parsedGap = Array.isArray(gap) ? gap.map((item) => `-${item}px`) : `-${gap}px`
  return buildResponsiveStyle(theme, 'margin-left', parsedGap)
}

export const buildFlexItemPadding = (props: ResponsiveGameCollection & { theme: HunnyTheme }) => {
  const { gap, theme } = props
  const parsedGap = Array.isArray(gap) ? gap.map((item) => `${item}px`) : `${gap}px`
  return buildResponsiveStyle(theme, 'padding', parsedGap)
}

export const buildFlexItemWidth = (props: ResponsiveGameCollection & { theme: HunnyTheme }) => {
  const { col, theme, isFeature } = props
  const getItemWidth = (col: number) => {
    const baseWidth = isFeature ? `calc(${100 / col}% * 2)` : `calc(${100 / col}%)`
    return baseWidth
  }
  const parsedWidth = Array.isArray(col) ? col.map((item) => getItemWidth(item)) : getItemWidth(col)
  return buildResponsiveStyle(theme, 'width', parsedWidth)
}

export const StyledFlexItems = styled(Flex)`
  flex-direction: row;
  flex-wrap: nowrap;
  scroll-snap-type: x mandatory;
  overflow-x: auto;
  width: 100%;
  scroll-behavior: smooth;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`

export const StyledFlexContainer = styled(Flex)<ResponsiveGameCollection>`
  ${buildResponsiveContainerGap}
  ${buildResponsiveContainerMarginLeft}

  ${StyledFlexItems} {
    & > * {
      ${buildFlexItemPadding}
      ${buildFlexItemWidth}

      flex-shrink: 0;
    }
  }
`
